import axiosInstance from "./axiosInstance";

const ProjectGalleryService = {
  getProjectGallery: () => axiosInstance.get("/api/project-gallery/"),

  createProjectGallery: async (data, beforeFile, afterFile) => {
    const fd = new FormData();
    fd.append("title", data.title || "");
    fd.append("order", data.order || 0);
    fd.append("language", data.language || "Marathi");

    if (beforeFile) {
      fd.append("before_image", beforeFile);
    }
    if (afterFile) {
      fd.append("after_image", afterFile);
    }

    console.debug(
      "ProjectGalleryService.createProjectGallery FormData:",
      Array.from(fd.entries()).map(([k, v]) => [k, v.name || v])
    );
    return axiosInstance.post("/api/project-gallery/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  updateProjectGallery: async (id, data, beforeFile, afterFile) => {
    // Always use FormData for updates to handle image uploads properly
    const fd = new FormData();
    fd.append("title", data.title || "");
    fd.append("order", data.order || 0);
    fd.append("language", data.language || "Marathi");

    if (beforeFile) {
      fd.append("before_image", beforeFile);
    }
    if (afterFile) {
      fd.append("after_image", afterFile);
    }

    // If no files provided, tell backend to keep existing images
    if (!beforeFile && !afterFile) {
      fd.append("keep_images", "true");
    }

    console.debug(
      "ProjectGalleryService.updateProjectGallery FormData:",
      Array.from(fd.entries()).map(([k, v]) => [k, v.name || v])
    );
    return axiosInstance.patch(`/api/project-gallery/${id}/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  deleteProjectGallery: (id) =>
    axiosInstance.delete(`/api/project-gallery/${id}/`),
};

export default ProjectGalleryService;
